const gallery = document.querySelector('.gallery');
const accordContainer = document.querySelector('.accord-container');
const galleryRow = document.querySelector('gallery-row');
const logoImageSection = document.querySelector('.fade-in-up');
const titleCustomSection = document.querySelector('.majortitle.h1.in-content');
const galleryTitle = document.querySelector('.gallery-title');

function toggleAccordionOnResize() {
    const isMobileView = window.innerWidth <= 768;
    
    const showMobile = [titleCustomSection, galleryTitle, accordContainer];
    const hideMobile = [galleryRow, logoImageSection, gallery];
    const showDesktop = [galleryRow, logoImageSection, gallery];
    const hideDesktop = [titleCustomSection, galleryTitle, accordContainer];
  
    function toggleVisibility(elements, isVisible) {
      elements.forEach(element => {
        if (element) {
          element.style.display = isVisible ? 'block' : 'none';
        }
      });
    }
  
    if (isMobileView) {
      toggleVisibility(showMobile, true);
      toggleVisibility(hideMobile, false);
    } else {
      toggleVisibility(showDesktop, true);
      toggleVisibility(hideDesktop, false);
    }
  }
  
toggleAccordionOnResize();
window.addEventListener('resize', toggleAccordionOnResize);

if (accordContainer) {
  const grid = document.querySelector('.slider__grid');

  if (grid) {
    const items = Array.from(grid.children);
    let currentAccordionTitle = null;
    let currentAccordionContent = [];

    items.forEach(item => {
      if (item.classList.contains('boutique-title')) {
        if (currentAccordionTitle && currentAccordionContent.length > 0) {
          const accordion = createAccordion(currentAccordionTitle, currentAccordionContent);
          accordContainer.appendChild(accordion);
        }
        currentAccordionTitle = item;
        currentAccordionContent = [];
      } else {
        const primaryBtn = item.querySelector('.btn--primary');
        const secondaryBtn = item.querySelector('.btn--secondary');
        const linkBtn = item.querySelector('.small-feature-link');

        const button = primaryBtn || secondaryBtn || linkBtn;
      
        if (button && button.textContent.trim()) {
          const linkElement = document.createElement('a');
          linkElement.classList.add('image-overlay__image-link');
          linkElement.setAttribute('href', button.closest('a') ? button.closest('a').getAttribute('href') : '#');
          
          const textContent = document.createElement('span');
          textContent.classList.add('boutique-btn');
          textContent.textContent = button.textContent.trim();
          linkElement.appendChild(textContent);
      
          currentAccordionContent.push(linkElement);
        }
      }
    });

    if (currentAccordionTitle && currentAccordionContent.length > 0) {
      const accordion = createAccordion(currentAccordionTitle, currentAccordionContent);
      accordContainer.appendChild(accordion);
    }
  }
}

function createAccordion(titleElement, contentElements) {
  const accordionContainer = document.createElement('div');
  accordionContainer.classList.add('accordion');

  const accordionHeader = document.createElement('div');
  accordionHeader.classList.add('accordion-header');

  const accordionTitle = document.createElement('div');
  accordionTitle.classList.add('accordion-title');
  accordionTitle.innerHTML = titleElement.innerHTML;
  accordionHeader.appendChild(accordionTitle);

  const toggleButton = document.createElement('button');
  toggleButton.classList.add('accordion-toggle');
  accordionHeader.appendChild(toggleButton);

  accordionContainer.appendChild(accordionHeader);

  const accordionContent = document.createElement('div');
  accordionContent.classList.add('accordion-content');
  contentElements.forEach(content => accordionContent.appendChild(content));
  accordionContainer.appendChild(accordionContent);

  accordionHeader.addEventListener('click', function() {
    const isOpen = accordionContainer.classList.toggle('open');
    document.querySelectorAll('.accordion.open').forEach(otherAccordion => {
        if (otherAccordion !== accordionContainer) {
          otherAccordion.classList.remove('open');
          otherAccordion.querySelector('.accordion-content').style.height = '0';
        }
    });
    if (isOpen) {
        let totalHeight = 0;
        contentElements.forEach(content => {
          totalHeight += content.scrollHeight;
        });
  
        accordionContent.style.height = totalHeight + 'px';
      } else {
        accordionContent.style.height = '0';
      }
  });

  return accordionContainer;
}